export enum EditMode {
    Split = 1,
    Merge = 2,
    Modify = 3,
    Add = 4,
    Buffer = 5,
    Number = 6
}

export interface IModifyTool {

    readonly name: string
    canExecute(): boolean
    execute(): void

}
